export default [
  {
    title: "Refunds",
    icon: "RefreshCcwIcon",
    tagVariant: "success",
    children: [
      {
        title: "Refund Requests",
        route: "refunds-request",
        resource: "Refund",
        action: "Request",
      },
      {
        title: "My Refund Queue",
        route: "myrefund-index",
        resource: "Refund",
        action: "MyQueue",
      },
      {
        title: "Refund Queue",
        route: "refundQueue-index",
        resource: "Refund",
        action: "Queue",
      },
      {
        title: "My Refund History",
        route: "refunds-history",
        resource: "Refund",
        action: "History",
      },
      {
        title: "Refund Report",
        route: "refund-report",
        resource: "Refund",
        action: "Request",
      },
      // {
      //   title: 'testing',
      //   route: 'pay-by-link',
      //   icon: 'ListIcon',
      //   resource: 'Orders',
      //   action: 'read',
      // },
    ],
  },
];
